import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CommonTable } from 'gnos-tables'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

import FormattedNumber from '../../../../../../../../../../../components/FormattedNumber'

import { LOCALE_PREFIX } from '../../constants'
import { prepareTableData } from './helpers'

import './style.scss'

@injectIntl
export default class ProfitDataTable extends Component {
    static propTypes = {
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        type: PropTypes.string,
    }

    render() {
        const { id, type, data, intl } = this.props

        if (_.isEmpty(data)) return null

        const tableData = prepareTableData(data, type)

        return (
            <div className={'size-data-table'}>
                <CommonTable
                    id={`${id}-size-common-table`}
                    itemIdentifier={'text'}
                    columnsDefinition={[
                        {
                            accessor: 'text',
                            Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.year` }),
                            headerClassnames: ['size-table-th'],
                            width: 60,
                        },
                        {
                            accessor: 'value',
                            Header: intl.formatMessage({
                                id: `${LOCALE_PREFIX}.value`,
                            }),
                            headerClassnames: ['size-table-th'],
                            Cell: (cell) => {
                                return (
                                    <FormattedNumber
                                        currency={cell?.value?.currency}
                                        decimalPlaces={0}
                                        customBase={1}
                                        displayCurrency
                                        displayNegativesRed={false}
                                        value={_.get(cell, 'value.amount')}
                                    />
                                )
                            },
                        },
                    ]}
                    staticData={tableData || []}
                />
            </div>
        )
    }
}
